import React, { PureComponent } from 'react';

class HelpModal extends PureComponent {
  render() {
    return (
      <div>
        <h2>Help</h2>
        <ul>
          <br />
          <li>
            <b>Video Version: </b>
            <a
              href="https://www.youtube.com/playlist?list=PLqLXjmptc90fgKa6EsLflKqwyQiE_7mFP"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.youtube.com/playlist?list=PLqLXjmptc90fgKa6EsLflKqwyQiE_7mFP
            </a>
          </li>
          <li>
            <b>HTML Version: </b>
            <a
              href="https://www.tickmark-software.com/media/tickmark-reporting-tool-manual.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.tickmark-software.com/media/tickmark-reporting-tool-manual.html
            </a>
          </li>
          <li>
            <b>PDF Version: </b>
            <a
              href="https://www.tickmark-software.com/media/tickmark-reporting-tool-manual.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.tickmark-software.com/media/tickmark-reporting-tool-manual.pdf
            </a>
          </li>
          <li>
            <b>Word Version: </b>
            <a
              href="https://www.tickmark-software.com/media/tickmark-reporting-tool-manual.docx"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.tickmark-software.com/media/tickmark-reporting-tool-manual.docx
            </a>
          </li>
        </ul>
      </div>
    );
  }
}

export default HelpModal;
